<div
  class="popup"
  [style.left.px]="x"
  [style.top.px]="y"
  #popupContentElement
  >
  @if (stationLine) {
    <!-- Spec §3a: the clicked point's station, one white-chip line at the top -->
    <div class="station-line" data-testid="map-popup-station">{{ stationLine }}</div>
  }
  @for (eachObj of popupContent; track eachObj; let isLast = $last) {
    @if (allowTypeOne(eachObj.type)) {
      <app-map-popup-type-one
        [data]="eachObj"
        (click)="eachObj.type === 'picture' ? onMoreClick(eachObj) : null"
        [style.cursor]="eachObj.type === 'picture' ? 'pointer' : 'default'"
        />
    }
    @if (allowTypeTwo(eachObj.type)) {
      <app-map-popup-type-two
        [data]="eachObj"
        />
    }
    @if (eachObj.type !== 'picture') {
      <div
        class="action"
        (click)="onMoreClick(eachObj)"
        >
        {{eachObj.more_link_text}}
      </div>
    }
    @if (!isLast) {
      <hr/>
    }
  }

</div>
